import { GlobalMessages } from '@shared/localization/messages';

import CheckCircleIcon from '@/assets/check-circle-icon.svg?react';
import { Button } from '@/components/atoms/Button';
import type { ModalStatelessProps } from '@/components/ModalStateless';
import { ModalStateless } from '@/components/ModalStateless';
import { useMessages } from '@/hooks/messages';

export type ConfirmationModalProps = Omit<ModalStatelessProps, 'title'> & {
  title: string;
  warningMessage: string;
  confirmButtonLabel?: string;
  onConfirm: () => void;
  isConfirmProcessing?: boolean;
};

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  title,
  warningMessage,
  confirmButtonLabel,
  open,
  onClose,
  onConfirm,
  isConfirmProcessing,
}) => {
  const globalMessages = useMessages(GlobalMessages);
  return (
    <ModalStateless
      title={title}
      size='s'
      open={open}
      onClose={onClose}
      buttons={
        <>
          <Button variant='secondary' outlined onClick={onClose}>
            {globalMessages.cancel()}
          </Button>
          <Button
            variant='primary'
            IconComponentLeft={CheckCircleIcon}
            onClick={() => onConfirm()}
            isProcessing={isConfirmProcessing}
            disabled={isConfirmProcessing}
          >
            {confirmButtonLabel || globalMessages.confirm()}
          </Button>
        </>
      }
    >
      <p>{warningMessage}</p>
      <p>{globalMessages.areYouSureYouWantToProceed()}</p>
    </ModalStateless>
  );
};
